import React, { Component } from 'react';
import { TabBar, Tab }      from '@rmwc/tabs';
import '@rmwc/tabs/styles';
import style                from './style.scss';
import Game                 from './Game';
import { classes }          from './helpers';

export default class App extends Component {

	state = {
		menuOpen : false,
		loading  : true,
		active   : 0,
		data     : {},
		tabs     : [],
	};

	updateTime = 360000;
	updateTimeout = 0;

	componentWillMount() {
		this.update();
	}

	componentWillUnmount() {
		clearTimeout( this.updateTimeout );
	}

	update = () => {
		if ( !this.state.loading ) {
			this.setState( { loading : true }, this.update );
			return;
		}

		const { groupBy, source } = this.props;

		let groups = [];
		let games = [];
		let resolved = 0;

		Promise.all( source.reduce( ( acc, src ) => {
			acc.push( fetch( new Request( src.jsonUrl ), { cache : 'no-cache' } ) );
			return acc;
		}, [] ) ).then( responses => {
			// consolidate responses into a single object

			new Promise( resolve => {
				responses.map( ( response, index ) => response.json().then( json => {
					/**
					 * @typedef {{$t:?string}} resultValue
					 */
					/**
					 * @typedef {{GAME_ID:resultValue,LEAGUE_NAME1:resultValue,LEAGUE_NAME2:resultValue,HT_NAME1:resultValue,HOME_SCORE:resultValue,VT_NAME1:resultValue,PERIOD1:resultValue,FORCED_VISIT_TEAM:resultValue,FORCED_HOME_TEAM:resultValue,VISIT_SCORE:resultValue,NOTES_ALL:resultValue,GAME_TIME:resultValue,UPDATED:resultValue,FINAL:resultValue}} scoreResultItem
					 */
					/**
					 * @typedef {{DATA:{RUN_EPOCH:{},RUN_DATE:{},RECORD:scoreResultItem[]}}} scoreResult
					 */

					/**
					 * @type scoreResultItem[]
					 */
					const data = Object.keys( json ).length > 0 ? (Array.isArray( json.DATA.RECORD ) ? json.DATA.RECORD : [ json.DATA.RECORD ]) : [];

					// collect all games for this request
					data && data.map( record => {
						const ht   = {
							      name  : record.HT_NAME1[ '$t' ] || record.FORCED_HOME_TEAM[ '$t' ] || '',
							      score : (record.HOME_SCORE[ '$t' ] || 0) * 1,
						      },
						      vt   = {
							      name  : record.VT_NAME1[ '$t' ] || record.FORCED_VISIT_TEAM[ '$t' ] || '',
							      score : (record.VISIT_SCORE[ '$t' ] || 0) * 1,
						      },
						      game = {
							      id           : record.GAME_ID[ '$t' ] || '',
							      league_short : record.LEAGUE_NAME1[ '$t' ] || '',
							      league       : record.LEAGUE_NAME2[ '$t' ] || '',
							      period       : record.PERIOD1[ '$t' ] || '',
							      final        : 'Y' === record.FINAL[ '$t' ] || false,
							      notes        : record.NOTES_ALL[ '$t' ] || null,
							      time         : record.GAME_TIME[ '$t' ] || '',
							      updated      : record.UPDATED[ '$t' ] || '',
						      };

						game.group = 'tab' === groupBy ? source[ index ].tab : game[ groupBy ] || record[ groupBy ][ '$t' ];
						game.id = `${game.id}-${game.group}`;

						if ( game.final ) {
							if ( ht.score > vt.score ) {
								ht.winner = true;
							} else {
								vt.winner = true;
							}
						}

						game.ht = ht;
						game.vt = vt;

						// build tabs
						if ( !groups.includes( game.group ) ) {
							groups[ index ] = game.group;
						}

						games.push( game );
					} );

					if ( resolved === responses.length - 1 ) {
						resolve();
					}

					++resolved;
				} ) );
			} ).then( () => {
				// All sources loaded. Update state
				this.setState( {
					data    : games,
					tabs    : groups.filter( g => g ),
					loading : false,
				}, () => {
					this.updateTimeout = setTimeout( this.update, this.updateTime );
				} );
			} );
		} );
	};

	setActiveTab = ( e, active ) => {
		this.setState( { active } );
	};

	render( { title, noScores, groupBy }, { loading, active, tabs, data }, context ) {
		return (
			<div className={style.wrapper}>
				{title && <div className={classes( 'mod-header', style.header )}>
					<h2>{title}</h2>
				</div>}
				{loading && <div>Loading scores...</div>}
				{(!loading && !Object.keys( data ).length) && <div>{noScores}</div>}
				{!loading && <div className={style.navWrap}>
					<TabBar activeTabIndex={active}>
						{tabs.map( ( label, index ) => (
							<Tab
								key={index}
								onInteraction={( e ) => this.setActiveTab( e, index )}
								label={label}
							/>
						) )}
					</TabBar>
				</div>}
				{!loading && <div className={style.gamesWrap}>
					{data.map( ( game ) => {
						if ( tabs[ active ] === game.group ) {
							return <Game key={game.id} {...game} />;
						}
					} )}
				</div>}
			</div>
		);
	}
}
